// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialConnect_wrapper__gfPoZ","apple":"SocialConnect_apple__iGF1E","google":"SocialConnect_google__BLWaO","facebook":"SocialConnect_facebook__jFSrY"};